import React, { useState, useEffect } from "react";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ActiveOrdersPage from "./pages/ActiveOrdersPage";
import UnlockPage from "./pages/UnlockPage";
import NavigationContext from "./components/NavigationContext";
import HttpService from "./sdk/HttpAxios";
import Logger from "./sdk/Logger";

function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [phone, setPhone] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [disableHome, setDisableHome] = useState(false);

  /**
   * Handle refresh / deep link:
   *  - /unlock?terminal=xxx
   */
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const terminal = params.get("terminal");

    if (window.location.pathname === "/unlock" && terminal) {
      setCurrentPage("unlock");
    } else {
      setCurrentPage("login");
    }
  }, []);

  /**
   * Handle orders page navigation
   */
  const onOrdersNext = ({ selectedOrder }) => {
    if (selectedOrder) {
      // User clicked Unlock on an order
      setSelectedOrder(selectedOrder);
      setCurrentPage("unlock");
    } else {
      // User clicked Back, go to login
      setCurrentPage("login");
    }
  };

  /**
   * Navigate to login
   */
  const navigateHome = () => {
    setCurrentPage("login");
    window.history.pushState({}, "", "/login");
  };

  /**
   * Handle login flow: request OTP and then verify
   * onNext is called from the login page with an object
   * containing phone and optionally otp.
   */
  const onLogin = async ({ phone: phoneNumber, otp }) => {
    const http = new HttpService();
    if (!otp) {
      // first step: request OTP
      await http.loginWithOtp(phoneNumber);
      setPhone(phoneNumber);
      // remain on login page, let the page show OTP input
      return;
    }

    // second step: verify OTP and navigate to orders
    await http.loginWithOtp(phoneNumber, otp);
    setPhone(phoneNumber);
    setCurrentPage("orders");
  };

  Logger.log("currentPage: ", currentPage);

  return (
    <NavigationContext.Provider
      value={{
        navigateHome,
        disableHome,
        setDisableHome,
      }}
    >
      {currentPage === "" && <>Loading…</>}

      {/* 1️⃣ Instructions */}
      {currentPage === "home" && (
        <HomePage onNext={() => setCurrentPage("login")} />
      )}

      {/* 2️⃣ Login / OTP */}
      {currentPage === "login" && <LoginPage onNext={onLogin} />}

      {/* 3️⃣ Active Orders */}
      {currentPage === "orders" && <ActiveOrdersPage onNext={onOrdersNext} />}

      {/* 4️⃣ Unlock */}
      {currentPage === "unlock" && <UnlockPage selectedOrder={selectedOrder} />}
    </NavigationContext.Provider>
  );
}

export default App;
